import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonV3 } from 'components/ComponentV2';
import Logo from 'components/Logo';

import { API_ROUTES } from 'lib/api-routes';
import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { TUserApiResponse } from 'lib/models/User.model';
import { useAuth } from 'lib/providers/AuthProvider';
import { apiInstance } from 'lib/utils/axios';

import { StepHeading } from '../StepHeading/StepHeading.component';
import styles from './Welcome.module.scss';

interface WelcomeProps {
  touchpointsExist: boolean;
  setFlowState: (flowState: string) => void;
}

export const Welcome: React.FC<WelcomeProps> = ({
  touchpointsExist,
  setFlowState,
}) => {
  const { updateUserApiResponse } = useAuth();

  const [t] = useTranslation('onboarding.recruiter');

  const handleOnClick = async () => {
    const flow_state = touchpointsExist
      ? ONBOARDING_FLOW_STATE.POST_1
      : ONBOARDING_FLOW_STATE.POST_3;
    const recruiter = { flow_state };
    const userResponse = await apiInstance.patch<TUserApiResponse>(
      API_ROUTES.RECRUITER_SIGNUP,
      {
        recruiter,
      }
    );
    updateUserApiResponse(userResponse.data);
    setFlowState(
      touchpointsExist
        ? ONBOARDING_FLOW_STATE.POST_1
        : ONBOARDING_FLOW_STATE.POST_3
    );
  };

  return (
    <div className={styles.welcomeScreen}>
      <Logo
        name="huzzle-new"
        size="small"
        color="black"
        className={styles.logo}
      />
      <div className={styles.content}>
        <StepHeading
          title={t('welcome.header.title')}
          desc={t('welcome.header.desc')}
          large
        />
        <ButtonV3
          className={styles.button}
          onClick={handleOnClick}
          color="primary"
          borderless
          size="xxlarge"
        >
          {t('welcome.button')}
        </ButtonV3>
      </div>
      <img
        src={'/images/welcome-onboarding.png'}
        className={styles.welcomeScreenImage}
      />
    </div>
  );
};
